import { api } from "@tt-app/api";
import {
  VUEX_ASSIGNMENT_ACTION_NAMES,
  VUEX_ASSIGNMENT_MUTATION_NAMES,
  VUEX_CONTENT_ACTION_NAMES,
  VUEX_CONTENT_NAMESPACE
} from "@tt-app/constants";
import { getAuthInfo } from "@tt-app/utils";
import { assignmentState } from "./state";

const { DETAILS_REQUEST, LIST_REQUEST, MINE } = VUEX_ASSIGNMENT_ACTION_NAMES;
const { ACTIVE_LIST, DETAILS, HISTORICAL_TOTAL, LIST, LOADING } = VUEX_ASSIGNMENT_MUTATION_NAMES;

const assignmentActions = {
  async [DETAILS_REQUEST]({ commit, rootGetters, dispatch }: any, payload: any) {
    try {
      commit(LOADING, true);
      commit(DETAILS, { assignment: undefined });

      const { assignmentId } = payload;
      const authInfo = await getAuthInfo(rootGetters);

      const response = await api.assignment.details({
        authInfo,
        assignmentId
      });

      commit(DETAILS, { assignment: response.data });
    } catch (error) {
      console.log({ error });

      const url = window.location.href;
      const urlLastSegment = url.substring(url.lastIndexOf("/") + 1);
      if (!assignmentState.details && payload.assignmentId == urlLastSegment) {
        window.location.replace(url.slice(0, url.lastIndexOf("/")));

        await dispatch(
          `${VUEX_CONTENT_NAMESPACE}/${VUEX_CONTENT_ACTION_NAMES.COURSE_DETAILS_REQUEST}`,
          payload
        );
      }
    } finally {
      commit(LOADING, false);
    }
  },
  async [LIST_REQUEST]({ commit, rootGetters }: any) {
    try {
      commit(LOADING, true);
      const authInfo = await getAuthInfo(rootGetters);

      const response = await api.assignment.list({
        authInfo
      });

      const assignments = response.data;

      assignments.forEach((assignment: any) => {
        assignment.startDate = new Date(Date.parse(assignment.startDate));
        assignment.dueDate = new Date(Date.parse(assignment.dueDate));

        if (assignment.submitted) {
          assignment.submitted = new Date(Date.parse(assignment.submitted));
        }
      });

      commit(LIST, { assignments });
    } catch (error) {
      console.log({ error });
    } finally {
      commit(LOADING, false);
    }
  },
  async [MINE]({ commit, rootGetters }: any) {
    commit(LOADING, true);
    const authInfo = await getAuthInfo(rootGetters);

    const {
      data: { activeAssignments, historicalTotal }
    } = await api.assignment.mine({ authInfo });

    activeAssignments.forEach((assignment: any) => {
      assignment.startDate = new Date(Date.parse(assignment.startDate as string));
      assignment.dueDate = new Date(Date.parse(assignment.dueDate as string));

      if (assignment.submitted) {
        assignment.submitted = new Date(Date.parse(assignment.submitted as string));
      }
    });

    const sortedActiveAssignments = activeAssignments.sort((assignmentA: any, assignmentB: any) => {
      return (
        assignmentA.dueDate - assignmentB.dueDate ||
        assignmentA.startDate - assignmentB.startDate ||
        assignmentA.title.localeCompare(assignmentB.title)
      );
    });

    commit(ACTIVE_LIST, { activeAssignments: sortedActiveAssignments });
    commit(HISTORICAL_TOTAL, { historicalTotal });
    commit(LOADING, false);
  }
};

export { assignmentActions };
